module.exports = {
  OFFER: 'offer',
  FEE: 'fee',
  OTHER: 'other',
};
